import React, { useEffect, useState } from "react";
import { Button, Table, Modal } from "react-bootstrap";
import Sidebar from "../../common/Sidebar";
import { HashLoader } from "react-spinners";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Swal from "sweetalert2";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";
import { toast } from "react-toastify";
import TattooGenerator from './TattooGenerator'
import { deleteTextToImageThunk, fetchTextToImageThunk, sortTextToImageThunk, updateTextToImagePositionThunk } from "../../apps/textToImageSlice";
import EditTextToImage from "./EditTextToImage";
import { changeLimit, changePage } from "../../apps/tatoosSlice";
import ViewTextToImage from "./ViewTextToImage";


const TextToImages = () => {
  const dispatch = useDispatch();
  const { textToImages, page, pageCount, total, limit } = useSelector((store) => store?.textToImage);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedTextToImage, setSelectedTextToImage] = useState(null);
  const [shuffledData, setShuffledData] = useState([]);
  const [isReordered, setIsReordered] = useState(false);
  const [isCheckedItems, setIsCheckedItems] = useState([]);
  const [isUnCheckedItems, setIsUnCheckedItems] = useState([]);
  const [isSortButtonVisible, setIsSortButtonVisible] = useState();
  const loading = false;
  useEffect(() => {
    dispatch(changeLimit(10))
    dispatch(fetchTextToImageThunk({ params: { limit: 10, page: 1 } }));
  }, [showEditModal, showAddModal]);

  useEffect(() => {
    if (textToImages) {
      setIsCheckedItems(
        textToImages
          .filter(textToImage => textToImage?.isSorted)
          .map(textToImage => textToImage?._id)
      );
      setShuffledData([...textToImages]);
    }
  }, [textToImages]);

  const shouldCancelStart = (e) => {
    const tagName = e.target.tagName.toLowerCase();
    return ["button", "input", "textarea", "select", "i"].includes(tagName);
  };

  // const handleEdit = (textToImage) => {
  //   setSelectedTextToImage(textToImage);
  //   setShowEditModal(true);
  // };

  const handleView = (tattoo) => {
    setSelectedTextToImage(tattoo);
    setShowViewModal(true);
  };

  const deleteTextToImage = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      const response = await dispatch(deleteTextToImageThunk({ id }));
      await dispatch(fetchTextToImageThunk({ params: { limit, page } }));
      if (response?.payload?.success) {
        Swal.fire("Deleted!", "The TextToImage has been deleted.", "success");
      }
      else {
        Swal.fire("Error!", "Failed to delete the TextToImage.", "error");
      }
    }
  };


  const handleCheckedItems = (e, id) => {
      setIsSortButtonVisible(true)
      if (e.target.checked) {
        setIsUnCheckedItems((prevItems) => prevItems.filter(Id => Id !== id));
        return setIsCheckedItems((prevItems) => [...prevItems, id]);
      }
      else {
        // Remove item ID from checkedItems state if unchecked
        setIsUnCheckedItems((prevItems) => [...prevItems, id])
        setIsCheckedItems((prevItems) => prevItems.filter(Id => Id !== id));
      }
    }
    const sortTextToImage = async () => {
     if( isCheckedItems.length !== 0){
  
        await dispatch(sortTextToImageThunk({ id:isCheckedItems,isSorted:true }))
        // setIsCheckedItems([])
      }
      if( isUnCheckedItems.length !== 0){
  
        await dispatch(sortTextToImageThunk({ id:isUnCheckedItems,isSorted:false  }))
      }
      dispatch(fetchTextToImageThunk({ params: { limit, page } }));
      setIsSortButtonVisible(false)
    }

  const SortableItem = SortableElement(({ item }) => (
    <tr key={item._id}>
      <td>{item?._id}</td>
      <td>{item?.prompt}</td>
      <td>{item?.aspect_ratio}</td>
      <td>{item?.uuid}</td>
      <td>{item?.position}</td>
      <td><input type="checkbox" checked={isCheckedItems.includes(item._id)} onChange={(e) => handleCheckedItems(e, item._id)} /></td>
      <td>
        <img src={item?.imageUrl} alt="Image-Url" width={120} height={150} />
      </td>
      <td>{item?.createdAt}</td>
      <td>
        <div className="d-flex">
          <button className="btn action_btn" onClick={() => handleView(item)}>
            <i className="fa fa-eye"></i>
          </button>
          {/* <button className="btn action_btn" onClick={() => handleEdit(item)}>
          <i className="fa fa-pencil"></i>
        </button> */}
          <button className="btn action_btn">
            <i className="fa fa-trash" onClick={() => deleteTextToImage(item._id)}></i>
          </button>
        </div>
      </td>
    </tr>
  ));
  const SortableList = SortableContainer(({ items }) => (
    <tbody>
      {items?.map((item, index) => (
        <SortableItem key={item._id} index={index} item={item} />
      ))}
    </tbody>
  ));

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const updatedData = arrayMoveImmutable(shuffledData, oldIndex, newIndex);
    setShuffledData(updatedData);
    setIsReordered(true);
  };

  const handleSavePosition = async () => {
    const reorderedIds = shuffledData.map((item) => item._id);
    await dispatch(updateTextToImagePositionThunk({ order: reorderedIds }));
    setIsReordered(false);
    dispatch(fetchTextToImageThunk({ params: { limit, page } }));
    setIsCheckedItems([])
    toast.success("Order updated successfully!");
  };




  const handlePageClick = async (data) => {
    await dispatch(changePage(data.selected + 1));
    await dispatch(
      fetchTextToImageThunk({
        params: {
          limit: limit,
          page: data.selected + 1,
        },
        // ...configObject,
      })
    );
  };
  const limitHandler = async (e) => {


    await dispatch(changeLimit(e.target.value));
    await dispatch(
      fetchTextToImageThunk({
        params: {
          limit: e.target.value,
          page: 1,
        },
        // ...configObject,
      })
    );
  };

  // const handleSavedTextToImage = async () => {
  //   setShowAddModal(false)
  //    dispatch(fetchTextToImageThunk({ params: { limit, page } }));
  // };


  return (
    <>
      <Sidebar />
      {loading ? (
        <div className="spinner">
          <HashLoader color="#757575" size={75} loading={true} />
        </div>
      ) : (
        <div className="card">
          <div className="card-header bg-white">
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="mb-0">Text To Image</h3>
              <Button className="btn add_btn" onClick={() => setShowAddModal(true)}>
                Add
              </Button>
            </div>
          </div>

          <DndProvider backend={HTML5Backend}>
            <div className="table-responsive">
              <Table>
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Prompt</th>
                    <th>Aspect Ratio</th>
                    <th>UUID</th>
                    <th>Position</th>
                    <th>Sort</th>
                    <th>Reference Image</th>
                    <th>Generated At</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <SortableList items={shuffledData} onSortEnd={onSortEnd} axis="y" shouldCancelStart={shouldCancelStart} />
              </Table>
            </div>

          </DndProvider>

          <div className="d-flex justify-content-end p-3">
            {isSortButtonVisible?.length !== 0 && (
              <Button onClick={sortTextToImage} className="me-2">Sort</Button>
            )
            }
            {isReordered && (
              <Button variant="success" className="btn btn-primary" onClick={handleSavePosition}>
                Save Position
              </Button>
            )}
          </div>

          {total > 0 && (
            <div className="d-flex justify-content-between align-items-center px-3 mb-2">
              <div>
                <select className="form-select" onChange={(e) => limitHandler(e)}>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
              <div>
                <ReactPaginate
                  previousLabel={"<"}
                  nextLabel={">"}
                  breakLabel={"..."}
                  pageCount={pageCount === 1 ? 1 : pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={(data) => handlePageClick(data)}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"pagination_prev"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"pagination_next"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                  forcePage={page - 1}
                />
              </div>
            </div>
          )}
        </div>
      )}

      <Modal show={showViewModal} size="lg" centered className="edit-modal">
        <Modal.Header closeButton onHide={() => setShowViewModal(false)} ><Modal.Title>Edit TextToImage</Modal.Title></Modal.Header>
        <Modal.Body>{selectedTextToImage ? <ViewTextToImage textToImageItem={selectedTextToImage} onClose={() => setShowViewModal(false)} /> : <p>No TextToImage selected.</p>}</Modal.Body>
      </Modal>

      <Modal show={showAddModal} size="xl">
        <Modal.Header closeButton onHide={() => setShowAddModal(false)} ></Modal.Header>
        <Modal.Body>
          <TattooGenerator setShowAddModal={setShowAddModal} onHide={() => setShowAddModal(false)} />
        </Modal.Body>
      </Modal>

      <Modal show={showEditModal} size="lg" centered className="edit-modal">
        <Modal.Header closeButton onHide={() => setShowEditModal(false)} ><Modal.Title>Edit TextToImage</Modal.Title></Modal.Header>
        <Modal.Body>{selectedTextToImage ? <EditTextToImage textToImageItem={selectedTextToImage} onClose={() => setShowEditModal(false)} /> : <p>No TextToImage selected.</p>}</Modal.Body>
      </Modal>
    </>
  );
};

export default TextToImages;
